import { combineReducers } from 'redux'
import InspectionInfoReducer from './reducers/inspection-info.reducer'

const InspectionReducers = combineReducers({
    inspectionInfo: InspectionInfoReducer,
})

export default InspectionReducers
export type RootState = ReturnType<typeof InspectionReducers>
